/* eslint-disable */
import { sortBy } from "lodash"


export enum House {
    Brobnar = "Brobnar",
    Dis = "Dis",
    Ekwidon = "Ekwidon",
    Elders = "Elders",
    Geistoid = "Geistoid",
    IronyxRebels = "IronyxRebels",
    Keyraken = "Keyraken",
    Logos = "Logos",
    Mars = "Mars",
    Ouboros = "Ouboros",
    Redemption = "Redemption",
    Sanctum = "Sanctum",
    Saurian = "Saurian",
    Shadows = "Shadows",
    Skyborn = "Skyborn",
    StarAlliance = "StarAlliance",
    Unfathomable = "Unfathomable",
    Untamed = "Untamed",
    Prophecy = "Prophecy",
    ArchonPower = "ArchonPower",
}

export class HouseUtils {
    static readonly values = [House.Brobnar, House.Dis, House.Ekwidon, House.Elders, House.Geistoid, House.IronyxRebels, House.Keyraken, House.Logos, House.Mars, House.Ouboros, House.Redemption, House.Sanctum, House.Saurian, House.Shadows, House.Skyborn, House.StarAlliance, House.Unfathomable, House.Untamed, House.Prophecy, House.ArchonPower]
    static valueOf = (value: string) => HouseUtils.values.find(enumValue => enumValue === value)
    static sort = (value: House[]) => sortBy(value, expansion => HouseUtils.values.indexOf(expansion))
}